import React from 'react'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getLocale } from 'lib/utils/getLocale'

import ContextActionsSelect from 'components/ContextActionsSelect/ContextActionsSelect'
import Link from 'components/Link'
import Button from 'components/UI/Button'

const AppHeaderMarketsNav = () => {
    const { t, i18n } = useTranslation()

    return (
        <ContextActionsSelect
            cssClass="app-header-desktop-markets-nav"
            renderCustomButton={({ renderChevron }) => (
                <Button
                    trackName="adActionsContext"
                    className="button button--plain"
                >
                    {t('common:navigation.markets')}
                    <div>
                        {renderChevron({ size: 's' })}
                    </div>
                </Button>
            )}
        >
            <ul>
                <li>
                    <Link
                        to={`${getLocale(i18n.language)}/fiksut-kaupat`}
                        title={t('common:navigation.billOfSale')}
                        trackName="bosList"
                    >
                        {t('common:navigation.billOfSale')}
                    </Link>
                </li>
                <li>
                    <Link
                        to={`${getLocale(i18n.language)}/kayttaja/asiakirjat/kauppakirjat`}
                        title={t('common:navigation.bosList')}
                        trackName="bosList"
                    >
                        {t('common:navigation.bosList')}
                    </Link>
                </li>
                <li>
                    <Link
                        to={`${getLocale(i18n.language)}/kayttaja/asiakirjat/tarjoukset`}
                        title={t('common:navigation.offers')}
                        trackName="offersList"
                    >
                        {t('common:navigation.offers')}
                    </Link>
                </li>
                {/* <li>
                    <Link
                        to="/user/documents/financing"
                        title={t('common:navigation.financingApplicationList')}
                        trackName="financingApplicationList"
                    >
                        {t('common:navigation.financingApplicationList')}
                    </Link>
                </li> */}
            </ul>
        </ContextActionsSelect>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
)(AppHeaderMarketsNav)
